import makeApiCall from "./master/axiosIndex";
export const phaseApis = {
  createPhase: (data: any): Promise<any> =>
    makeApiCall({ url: "/phase/create", method: "post", data }),
  updatePhase: (data: any): Promise<any> =>
    makeApiCall({ url: "/phase/update", method: "put", data }),
  archivePhase: (phaseId: number): Promise<any> =>
    makeApiCall({ url: `/phase/archive/${phaseId}`, method: "patch" }),
  deletePhase: (phaseId: number): Promise<any> =>
    makeApiCall({ url: `/phase/delete/${phaseId}`, method: "delete" }),
  changePhaseStatus: (
    phaseId: number,
    status: "Draft" | "Active" | "InProgress" | "OnHold" | "Cancelled"
  ): Promise<any> =>
    makeApiCall({
      url: `/phase/statusChange/${phaseId}?status=${status}`,
      method: "patch",
    }),
  listPhases: (params: {
    phaseStatus?: any;
    phaseOwnerIds?: string;
    projectIds?: string;
    projectGroupIds?: string;
    tagIds?: string;
    sortOrder: "ASC" | "DESC";
    direction: "F" | "B" | "P";
    pageSize: number;
    pageDiff: number;
    paginationId?: string;
    searchQuery?: string;
    derivedProjectStatus?: string;
    startDate?: any;
    endDate?: any;
    completionPercentage?: any;
  }): Promise<any> =>
    makeApiCall({
      url: `/phase/list`,
      method: "get",
      params,
    }),
  getPhaseById: (
    phaseId: string | number,
    derivedProjectStatus?: string
  ): Promise<any> =>
    makeApiCall({
      url: `/phase/id/${phaseId}`,
      method: "get",
      params: { derivedProjectStatus },
    }),
  updatePhaseStatus: (
    phaseId: string | number,
    status: string,
    phaseOnholdReason?: string,
    phaseETAResolution?: string
  ): Promise<any> =>
    makeApiCall({
      url: `/phase/statusChange/${phaseId}`,
      method: "patch",
      params: { status, phaseOnholdReason, phaseETAResolution },
    }),
  fetchGroupByPhasesList: async (params: any, projectId: any): Promise<any> =>
    makeApiCall({
      url: "/phase/groupByList/" + projectId,
      method: "get",
      params,
    }),
  getTagsFilterData: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/phase/filters/tags`,
      method: "get",
      params: { projectId },
    });
  },
  getOwnersFilterData: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/phase/filters/owners`,
      method: "get",
      params: { projectIds: projectId },
    });
  },
  fetchPhaseDropDown: (params: any): Promise<any> =>
    makeApiCall({
      url: `/phase/dropdown`,
      method: "get",
      params,
    }),
  fetchTaskByPhaseDropDown: (taskId: number): Promise<any> =>
    makeApiCall({
      url: `/task/taskPhase/${taskId}`,
      method: "get",
    }),
  fetchPhaseStatusTimeline: (
    projectId: number,
    entityId: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/task/fetchStatusTimelines/${projectId}/Phase/${entityId}`,
      method: "get",
    });
  },
  fetchActivityStreamlines: (
    projectId: number,
    entityId: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/activity/fetchActivityStreamlines/${projectId}/Phase/${entityId}`,
      method: "get",
    });
  },
  getProjectPhaseWeightage: (projectId: number): Promise<any> =>
    makeApiCall({
      url: `/phase/projectPhaseWeightage`,
      method: "get",
      params: { projectId },
    }),
};
